import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89af6932"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "table-responsive" }
const _hoisted_3 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_4 = { class: "fw-bolder text-muted" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-250px" }, "Skill", -1))
const _hoisted_6 = { class: "min-w-150px" }
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Base rate", -1))
const _hoisted_9 = { class: "min-w-150px" }
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Level bonus", -1))
const _hoisted_12 = { class: "min-w-150px" }
const _hoisted_13 = { class: "d-flex flex-column" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Weekend bonus", -1))
const _hoisted_15 = { class: "min-w-150px" }
const _hoisted_16 = { class: "d-flex flex-column" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Night bonus", -1))
const _hoisted_18 = { class: "text-end" }
const _hoisted_19 = { class: "d-flex justify-content-end" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px text-end" }, "Actions", -1))
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "fs-5 fw-bold" }
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = ["onUpdate:modelValue"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_28 = { class: "text-end" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "d-flex justify-content-end mt-4" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 0,
  class: "spinner-border-sm me-2 spinner-border"
}
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomizeRatesModal = _resolveComponent("CustomizeRatesModal")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_component_CustomizeRatesModal, {
      isSaving: _ctx.isSavingCustom,
      key: _ctx.modalKey,
      onSaveLevelRates: _ctx.handleSaveRatesLevel,
      skillId: _ctx.skillID
    }, null, 8, ["isSaving", "onSaveLevelRates", "skillId"])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_4, [
              _createElementVNode("th", null, [
                _createVNode(_component_el_checkbox, {
                  style: {"padding":"0 8px"},
                  onChange: _cache[0] || (_cache[0] = event => _ctx.handleSelectAllRows(event))
                })
              ]),
              _hoisted_5,
              _createElementVNode("th", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control w-100 w-xl-75 h-32px",
                      id: "maskedInput",
                      type: "number",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bulkEdit.base_rate) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.bulkEdit.base_rate]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("th", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control w-100 w-xl-75 h-32px",
                      id: "maskedInput",
                      type: "number",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bulkEdit.level_bonus) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.bulkEdit.level_bonus]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("th", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control w-100 w-xl-75 h-32px",
                      id: "maskedInput",
                      type: "number",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bulkEdit.weekend_bonus) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.bulkEdit.weekend_bonus]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("th", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control w-100 w-xl-75 h-32px",
                      id: "maskedInput",
                      type: "number",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.bulkEdit.night_bonus) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.bulkEdit.night_bonus]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("th", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", {
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleBulkEdit && _ctx.handleBulkEdit(...args))),
                    style: {"height":"28px"},
                    class: "d-flex align-items-center btn btn-sm btn-primary"
                  }, " Apply ")
                ])
              ]),
              _hoisted_20
            ])
          ]),
          (_ctx.hasModel)
            ? (_openBlock(), _createElementBlock("tbody", { key: _ctx.key }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rates.skills, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", _hoisted_21, [
                      _createVNode(_component_el_checkbox, {
                        style: {"padding":"0 8px"},
                        onChange: ($event: any) => (_ctx.handleBulkEditList(item.id)),
                        checked: _ctx.bulkEditList.includes(item.id)
                      }, null, 8, ["onChange", "checked"])
                    ]),
                    _createElementVNode("td", _hoisted_22, _toDisplayString(item.name), 1),
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control w-100 w-xl-75 h-32px",
                        id: "maskedInput",
                        type: "number",
                        "onUpdate:modelValue": ($event: any) => ((_ctx.model[item.id].base_rate) = $event)
                      }, null, 8, _hoisted_23), [
                        [_vModelText, _ctx.model[item.id].base_rate]
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control w-100 w-xl-75 h-32px",
                        id: "maskedInput",
                        type: "number",
                        "onUpdate:modelValue": ($event: any) => ((_ctx.model[item.id].level_bonus) = $event)
                      }, null, 8, _hoisted_24), [
                        [_vModelText, _ctx.model[item.id].level_bonus]
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control w-100 w-xl-75 h-32px",
                        id: "maskedInput",
                        type: "number",
                        "onUpdate:modelValue": ($event: any) => ((_ctx.model[item.id].weekend_bonus) = $event)
                      }, null, 8, _hoisted_25), [
                        [_vModelText, _ctx.model[item.id].weekend_bonus]
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control w-100 w-xl-75 h-32px",
                        id: "maskedInput",
                        type: "number",
                        "onUpdate:modelValue": ($event: any) => ((_ctx.model[item.id].night_bonus) = $event)
                      }, null, 8, _hoisted_26), [
                        [_vModelText, _ctx.model[item.id].night_bonus]
                      ])
                    ]),
                    _hoisted_27,
                    _createElementVNode("td", _hoisted_28, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.handleCustomizeModal(item.id)),
                        class: "btn btn-sm btn-primary"
                      }, " Customize ", 8, _hoisted_29)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("button", {
          disabled: _ctx.isSavingRates,
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.emitSaveRates && _ctx.emitSaveRates(...args))),
          class: "btn btn-success fw-bold text-white"
        }, [
          (_ctx.isSavingRates)
            ? (_openBlock(), _createElementBlock("span", _hoisted_32))
            : _createCommentVNode("", true),
          _hoisted_33
        ], 8, _hoisted_31)
      ])
    ])
  ], 64))
}